import React, { useState, useEffect, Component } from "react";
import axios from "axios";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import Form from "react-bootstrap/Form";
import ExportBLFirstDT from "./ExportBL_include/ExportBLFirstDT";
import ExportBLSecondDT from "./ExportBL_include/ExportBLSecondDT";
import ExportBLAttachedDT from "./ExportBL_include/ExportBLAttachedDT";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const ExportBL = () => {
  const [baseUrl, setBaseUrl] = useState("http://mol.evolve-demo.com/api/");
  const [pageComponent, setPageComponent] = useState("exportbl");

  // === Inputs Valuse Hadle === //
  const firstPageinitialValues = {
    BLNO: "",
    Date: "",
    Hbl: "",
    VesCode: "",
    VesDesc: "",
    voyCode: "",
    voyDesc: "",
    PortLoadCode: "",
    PortLoadDesc: "",
    PortDischCode: "",
    PortDischDesc: "",
    PlaceOfDelivery: "",
    PlaceOfReceipt: "",
    PreCarrageBy: "",
    FinalDestination: "",
    GrossWeight: "",
    NoOfConPack: "",
    Measurments: "",
    TotNoOfConPackInWord: "",
    Shipper: "",
    Consignee: "",
    NotifyParty: "",
    DeliveryOfGoods: "",
    ConNoSealNOMarks: "",
    NoOfConPKGDesc: "",
    FreightChargers: "",
    RevenueTons: "",
    Rate: "",
    Per: "",
    Prepaid: "",
    Collect: "",
    ExchangeRate: "",
    PrepaidAt: "",
    PayableAt: "",
    TotPaidNationalCurr: "",
    PlaceAndDateOfIssue: "",
    NoOfOrginalWayBill: "",
    AditionalDetails: "",
  };
  const [pageValuesData, setpageValuesData] = useState(firstPageinitialValues);

  const pageValueHadle = (e) => {
    if (e.target.name == "BLNO") {
      axios
        .get(
          `http://mol.evolve-demo.com/api/exportbl/get_details_based_on_bill_number/${e.target.value}`
        )
        .then((response) => {
          console.log(response);
        });
    }

    const { name, value } = e.target;
    setpageValuesData({ ...pageValuesData, [name]: value });
  };

  const dataTest = () => {
    console.log(pageValuesData);
  };

  // === Inputs Valuse Hadle End === //

  const handleContainerCUS = () => {
    axios
      .post(`http://mol.evolve-demo.com/api/exportbl/store`, pageValuesData)
      .then((response) => {
        toast.success("Successfully Save Data ! ", {
          position: toast.POSITION.TOP_RIGHT,
        });
        setTimeout(window.location.reload.bind(window.location), 2000);
      })
      .catch((error) => {
        console.error(error);
        alert(error);
      });
  };

  return (
    <Container>
      <ToastContainer autoClose={2000} />
      <Tabs
        defaultActiveKey="home"
        id="justify-tab-example"
        className="mb-3 mt-3 pt-2"
        justify
      >
        <Tab eventKey="home" title="Detail page 1">
          <ExportBLFirstDT
            onpageValueHadleFunction={pageValueHadle}
            pageValuesData={pageValuesData}
          />
        </Tab>
        <Tab eventKey="profile" title="Detail page 2">
          <ExportBLSecondDT
            onpageValueHadleFunction={pageValueHadle}
            pageValuesData={pageValuesData}
          />
        </Tab>
        <Tab eventKey="" title="Attached Sheet Details">
          <ExportBLAttachedDT
            onpageValueHadleFunction={pageValueHadle}
            pageValuesData={pageValuesData}
          />
        </Tab>
      </Tabs>
      <Row>
        <Col>
          <Form className="mt-4 bottom-border pb-3">
            <Row className="text-center">
              <Col className="text-end">
                <Button className="ms-3" variant="primary" onClick={dataTest}>
                  Data Test
                </Button>
                <Button
                  className="ms-3"
                  variant="primary"
                  onClick={handleContainerCUS}
                >
                  Save
                </Button>

                <Button className="ms-3" variant="primary">
                  New
                </Button>

                <Button className="ms-3" variant="primary">
                  Update
                </Button>
                <Button className="ms-3" variant="primary">
                  Delete
                </Button>

                <Button className="ms-3" variant="primary">
                  Print
                </Button>

                <Button className="ms-3" variant="primary" type="submit">
                  Cancel
                </Button>
              </Col>
            </Row>
          </Form>
        </Col>
      </Row>
    </Container>
  );
};

export default ExportBL;
